import { inject, isDevMode, resource } from '@angular/core';
import { FingerprintjsProAngularService } from '@fingerprintjs/fingerprintjs-pro-angular';
import { createInjectionToken } from 'ngxtension/create-injection-token';

export const [injectFingerprint, provideFingerprint] = createInjectionToken(() => {
  const fingerprint = inject(FingerprintjsProAngularService);
  return resource({
    loader: async () => {
      try {
        return await fingerprint.getVisitorData({ extendedResult: true });
      } catch (error) {
        if (isDevMode()) console.error('Error loading fingerprint data', error);
        return null;
      }
    },
  });
});
